var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9822 8.99957H2.78764V2.99815C2.78764 2.82364 2.63525 2.68229 2.4471 2.68229H1.76602C1.57787 2.68229 1.42548 2.82364 1.42548 2.99815V9.6313C1.42548 9.98013 1.73047 10.263 2.10656 10.263H11.9822C12.1704 10.263 12.3228 10.1217 12.3228 9.94716V9.31543C12.3228 9.14092 12.1704 8.99957 11.9822 8.99957ZM11.3012 3.31402H8.78839C8.33335 3.31402 8.1054 3.82433 8.42721 4.12283L9.1168 4.76245L7.55521 6.21108L5.99362 4.76265C5.72757 4.51588 5.29636 4.51588 5.03053 4.76265L3.56854 6.11869C3.43552 6.24208 3.43552 6.44206 3.56854 6.56544L4.04998 7.01199C4.18301 7.13538 4.39861 7.13538 4.53163 7.01199L5.51197 6.1025L7.07356 7.55094C7.33961 7.79771 7.77082 7.79771 8.03665 7.55094L10.0799 5.65575L10.7695 6.29538C11.0913 6.59387 11.6415 6.38244 11.6415 5.96036V3.62988C11.6417 3.45537 11.4893 3.31402 11.3012 3.31402Z",
    fill: "white",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.8a7cdf496382e0f771a29d2f9ac1b647.svg";
export { ForwardRef as ReactComponent };